export default "__VITE_ASSET__DUfeSpYp__"